import { useTranslation } from 'react-i18next';

import { Item, Title, Value } from './rack-state-item.styled';

export const RackStateItem = (props) => {
  const { title, info, active, ...rest } = props;
  const { t } = useTranslation();

  return (
    <Item title={t('sensors.' + info)} {...rest}>
      <Value $active={active}>
        <Title>{t('sensors.' + title)}</Title>
      </Value>
    </Item>
  );
};
